import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import {
  AppDispatch,
  FixMe,
  Project,
  RootState,
} from '@greenkub-fronts/shared/interface';
import {
  getCurrentProject,
  openModalSignature,
} from '@greenkub-fronts/domain/signature';

import DechargeClient from '../../../ui/web/template/decharge-client/decharge-client';

export interface DechargeClientFeatureProps {
  sign1Ref: FixMe;
}

const DechargeClientFeature = (props: DechargeClientFeatureProps) => {
  const { sign1Ref } = props;

  const dispatch = useDispatch<AppDispatch>();

  const { signature, signatures, isSignature } = useSelector(
    (state: RootState) => state.signature
  );

  const project = useSelector((state: RootState) => getCurrentProject(state));

  const [lastName, setLastName] = useState<string>();
  const [firstName, setFirstName] = useState<string>();
  const [date] = useState(DateTime.local());

  useEffect(() => {
    if (!project) return;
    if (!lastName)
      setLastName(
        project?.dechargeTravauxSansDeclaration?.lastName
          ? project.dechargeTravauxSansDeclaration.lastName
          : project?.customer.lastName
      );
    if (!firstName)
      setFirstName(
        project?.dechargeTravauxSansDeclaration?.firstName
          ? project.dechargeTravauxSansDeclaration.firstName
          : project?.customer.firstName
      );
  }, [project]);

  return (
    <DechargeClient
      project={project as Project}
      signatures={signatures}
      lastName={lastName || ''}
      firstName={firstName || ''}
      date={date}
      isSignature={isSignature}
      signature={signature}
      sign1Ref={sign1Ref}
      handleOpenModalSignHandler={(index: number) =>
        dispatch(openModalSignature({ currentIndexSignature: index }))
      }
    />
  );
};

export default DechargeClientFeature;
